module.exports = __webpack_public_path__ + "images/signup_header_mobile.f254a0f9.jpg";